import React, { useEffect, useState } from 'react';
import "./parametres.css";
import { Col, Row, Input, Switch, DatePicker, ConfigProvider, Spin } from 'antd';
import Title from 'antd/es/typography/Title';
import { useDispatch, useSelector } from 'react-redux';
import { ListParametrageFormActions } from '../../redux/actions/ListParametrageFormActions';
import dayjs from 'dayjs';
import { ConfigurLimitReponseActions } from '../../redux/actions/ConfigurLimitReponseActions';
import { ConfigurExpirationReponseActions } from '../../redux/actions/ConfigurExpirationReponseActions';
import frFR from 'antd/es/locale/fr_FR';

const Parametres = ({ donneeFormulaire }) => {
   const formId = donneeFormulaire.id;
// dayjs.locale('fr');
//     const onChange = checked => {
//   console.log(`switch to ${checked}`);
// };
const dispatch = useDispatch();


      const {parametresForm: dataParametresForm, loading : loadingParametresForm } = useSelector((state) => state.listDesParametresForm);
      useEffect(() => {
         if (formId) {
            dispatch(ListParametrageFormActions(formId));
         }
      }, [dispatch, formId]);
const [limitR, setLimitR] = useState();

      // console.log(dataParametresForm?.settings?.response_deadline?.value);
   
       const [dateValue, setDateValue] = useState();

useEffect(() => {
  if (dataParametresForm?.settings?.max_responses?.value || (dataParametresForm?.settings?.max_responses?.value === 0)) {
    setLimitR(dataParametresForm?.settings?.max_responses?.value);
  }
   
      setDateValue(dataParametresForm?.settings?.response_deadline?.value
      ? dayjs(dataParametresForm?.settings?.response_deadline?.value)
      : "");
   
}, [dataParametresForm]);

const {loading: loadingMaxReponses, confLimitReponse} = useSelector((state) => state.creatLimitReponse );
// console.log(confLimitReponse);
const {loading: loadingDeadline, confExpirReponse } = useSelector((state)  => state.createExpiration );

   // console.log(confExpirReponse);

  const handleSubmitLimitR= async () => {
    
      const updatedLimitR = {
        key: "max_responses",
        value: limitR,
      };
      // console.log(updatedLimitR);
    
      try {
        await dispatch(ConfigurLimitReponseActions(formId, updatedLimitR));
        await dispatch(ListParametrageFormActions(formId));

      } catch (error) {
      }
    };

     const handleSubmitExpirR= async () => {
      const updatedExpirR = {
        key: "response_deadline",
        value: dateValue.hour(23).minute(59).second(59).format('YYYY-MM-DDTHH:mm:ss'),
      };
      // console.log(updatedExpirR);
      try {
        await dispatch(ConfigurExpirationReponseActions(formId, updatedExpirR));
        await dispatch(ListParametrageFormActions(formId));

      } catch (error) {
      }
    };
   //  console.log(dateValue);

    return (
            <Row>
                 <Col span={24}>
                 <Title level={5} >Limites de réponses</Title>
                    <p>Décrire le nombre maximum de réponses</p>
                   
                 </Col>
                 <Col span={24} style={{display:"flex"}}>
                     <Input key="max_responses" value={limitR} onChange={(e) => setLimitR(e.target.value) } type="number" style={{width:"50%", marginRight:"2%"}} />
                     <Spin className="spinLoading" spinning={loadingMaxReponses} tip="Enregistrement en cours..." size="small">
                        <button disabled={loadingMaxReponses} onClick={handleSubmitLimitR} style={{backgroundColor:"#43CE0C", color:"#fff", border:"none", height:"4.6vh", borderRadius:"0.5rem"}}>Enregistrer</button>
                     </Spin>
                     </Col>

                 <Col span={24}>
                    <Title level={5} >Date d'expiration</Title>
                    <p>Décrire la date limite pour répondre</p>
                 </Col>
                  <Col span={24} style={{display:"flex"}}>
                    <ConfigProvider locale={frFR}>
                        <DatePicker
                           key="response_deadline"
                           value={dateValue}
                           format="DD/MM/YYYY"
                           style={{ width: '50%', marginRight: '2%' }}
                           onChange={(date) => setDateValue(date)}
                        />
                        </ConfigProvider>
                      {/* <Input type="date" key="response_deadline"  value={dataParametresForm?.settings?.response_deadline?.value}   style={{width:"50%", marginRight:"2%"}}  /> */}
                     <Spin className="spinLoading" spinning={loadingDeadline} tip="Enregistrement en cours..." size="small">
                      <button disabled={loadingDeadline} onClick={handleSubmitExpirR} style={{backgroundColor:"#43CE0C", color:"#fff", border:"none", height:"4.6vh", borderRadius:"0.5rem"}}>Enregistrer</button>
                     </Spin>
                     </Col>

                 {/* <Col span={24}>
                    <Title level={5} >Mandataire réponse</Title>
                    <p style={{width:"50%"}}>Voter les submissions à réptri-le  <Switch  onChange={onChange}  style={{float:"right"}}/></p>
                     
                 </Col>

                 <Col span={24}>
                    <Title level={5} >Afficher le score</Title>
                    <p style={{width:"50%"}}>Voter le score à l'apo des respondants   <Switch  onChange={onChange}  style={{float:"right"}}/></p>
                 </Col> */}
            </Row>
    );
};

export default Parametres;